<template>
	<button
		v-if="showButton && !playerIsAdMode"
		class="back-to-live"
		@click="handleClick"
	>
		<span>{{ $I18n.trans('commons.back_to_live') }}</span>
		<Icon
			icon-name="arrow-right"
			size="lg"
			:inline="true"
		/>
	</button>
</template>

<script>
export default {
	props: {
		isLookingBackInLiveEvent: {
			type: Boolean,
		},
		playerIsAdMode: {
			type: Boolean,
		},
	},
	data() {
		return {
			showButton: false,
			timerId:    null,
		};
	},
	watch: {
		isLookingBackInLiveEvent(newVal, oldVal) {
			if (newVal && !oldVal) { // isLookingBackInLiveEvent changed from false to true
				this.showButton = true;
				// Set up a 5 second timer to hide the button
				this.timerId = setTimeout(() => {
					this.showButton = false;
				}, 5000);
			} else if (!newVal && oldVal) { // isLookingBackInLiveEvent changed from true to false
				this.showButton = false;
				// Clear the timer if it's still running
				if (this.timerId) {
					clearTimeout(this.timerId);
					this.timerId = null;
				}
			}
		},
	},
	methods: {
		handleClick(event) {
			event.stopPropagation();
			this.$emit('back-to-live');
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.back-to-live {
	display: flex;
	border-radius: 2px;
	float: right;
	background: var(--color-red);
	color: var(--color-white);
	padding: 14px 24px;
	cursor: pointer;
	margin-right: 24px;
	margin-bottom: 24px;
	position: absolute;
	bottom: 48px;
	right: 0;
	transition: all 0.2s ease-in-out;

	span {
		margin-right: 10px;
	}

	@media (max-width: 640px) {
		transform: scale(0.7);
		transform-origin: bottom right;
	}
}
</style>
